import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard'
import Help from './views/Help'
import AuthRouter, { AuthFilter } from './auth/router'
import SensorRouter from './sensor/router'
import CareCallRouter from './carecall/router'
import VoiceMessageRouter from './voicemessage/router'
import AdminRouter from './admin/router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Dashboard,
      name: 'dashboard',
      meta: {
        dark: true,
        loader: true
      }
    },
    {
      path: '/help',
      component: Help,
      name: 'help',
    },
    CareCallRouter,
    VoiceMessageRouter,
    SensorRouter,
    AdminRouter,
    AuthRouter
  ]
})

router.beforeEach(AuthFilter)
router.beforeEach((to, from, next) => {
  if (to.meta.loader) {
    store.commit('core/setViewLoading', true)
  }
  next()
},)
export default router

